namespace Solovis.Reports.ReportHelpers.ReportLibrary {

    export class QuickStartControl extends Solovis.UI.BaseControl {

        private _quickStartPanelControlHost;
        private _showQuickStartPanelCallback;
        private _hideQuickStartPanelCallback;

        constructor(options) {
            super(options);

            this._quickStartPanelControlHost = options.quickStartPanelControlHost;
            this._showQuickStartPanelCallback = options.showQuickStartPanelCallback;
            this._hideQuickStartPanelCallback = options.hideQuickStartPanelCallback;
        }


        public doRender() {
            let self = this;

            this.container.css("padding-right", "10px");
            this.container.css("padding-top", "10px");

            $(this.container).dxAccordion({
                items: [
                    {
                        title: "Quick Start",
                        itemTemplate: function (itemData, itemIndex, itemElement) {                            
                            let holdingsAndPerfRow = $("<div>").appendTo(itemElement);
                            let holdingsAndPerfLink = $("<a>").text("Holdings And Performance").appendTo(holdingsAndPerfRow);

                            holdingsAndPerfLink.click(function () {
                                let holdingsAndPerfQuickStartControl = new HoldingsAndPerformanceQuickStartControl({
                                    controlHost: self._quickStartPanelControlHost,
                                    closeHandler: self._hideQuickStartPanelCallback
                                });
                                holdingsAndPerfQuickStartControl.setAsCurrentControl();
                                self._showQuickStartPanelCallback();
                            });

                            let exposureRow = $("<div>").appendTo(itemElement);
                            let exposureLink = $("<a>").text("Exposure").appendTo(exposureRow);

                            exposureLink.click(function () {                                
                                let exposureQuickStartControl = new ExposureQuickStartControl({                                    
                                    controlHost: self._quickStartPanelControlHost,
                                    closeHandler: self._hideQuickStartPanelCallback                                    
                                });
                                exposureQuickStartControl.setAsCurrentControl();
                                self._showQuickStartPanelCallback();
                            });

                            let peRow = $("<div>").appendTo(itemElement);
                            let peLink = $("<a>").text("Private Equity").appendTo(peRow);

                            peLink.click(function () {
                                let peQuickStartControl = new PrivateEquityQuickStartControl({
                                    controlHost: self._quickStartPanelControlHost,
                                    closeHandler: self._hideQuickStartPanelCallback
                                });
                                peQuickStartControl.setAsCurrentControl();
                                self._showQuickStartPanelCallback();
                            });
                        }
                    }
                ],
                itemTemplate: function (itemData, itemIndex, itemElement) {
                    if (itemData.itemTemplate) {
                        itemData.itemTemplate(itemData, itemIndex, itemElement);
                    }
                }
            });
        }

        public updateSpaceAvailable(width, height) {
            if (this.container) {
                this.container.outerWidth(width);
                this.container.outerHeight(height);
            }
        }
    }


    export interface QuickReportLink {
        label: string;
        comment?: string;
        href: string;
        format: string;
    }


    export class BaseQuickStartPanelControl extends Solovis.UI.BaseControl {

        private _closeHandler;

        constructor(options) {
            super(options);

            this._closeHandler = options.closeHandler;
        }

        public doRender() {
            let closeDiv = $("<div>")
                .css("float", "left")
                .css("font-size", "18px")
                .css("padding-right", "10px")
                .css("padding-top", "5px")
            $("<span>").addClass("fa fa-arrow-left").appendTo(closeDiv);            
            closeDiv.css("cursor", "pointer");
            closeDiv.click(() => {
                if (this._closeHandler) {
                    this._closeHandler();
                }
            });
            

            let headerDiv = $("<h1>")
                .text(this.title())
                .css("font-weight", "bold")
                .css("border-left", "none")
                .appendTo(this.container);
            closeDiv.appendTo(headerDiv);

            this.renderPanel();
        }

        public renderPanel() {
            // Called after rendering the header.
        }

        public title(): string {
            return "BasePanel";
        }

        public static renderQuickReportLinksToDiv(links: QuickReportLink[], reportLinkListDiv) {
            $(reportLinkListDiv).html("");

            $(links).each(function (i, linkEntry: any) {
                let link: QuickReportLink = linkEntry;
                let reportDiv = $("<div>").css("margin-bottom", "15px").appendTo(reportLinkListDiv);

                $("<div>").text(link.comment).appendTo(reportDiv);
                let linkDiv = $("<div>").css("padding-left", "15px").appendTo(reportDiv);
                $("<a>").text(link.label).attr("href", link.href).appendTo(linkDiv);
                $("<span class='fa fa-external-link' title='Open In New Tab'>")
                    .css("padding-left", "10px")
                    .css("cursor", "pointer")
                    .appendTo(linkDiv)
                    .click(() => {
                        window.open(link.href, "_blank");
                    });
            });
        }
    }


    export class ExposureQuickStartControl extends BaseQuickStartPanelControl {

        private _portalServices: Solovis.Portal.IPortalServices;
        private _exposureProfiles: InvData.Models.IdAndCodeObjectIndex<any>;

        private _portfolioParameterSet: Solovis.Reports.ParameterSet;
        private _profileParameterSet: Solovis.Reports.ParameterSet;        

        private _reportListDiv;

        constructor(options) {
            super(options);

            this._portalServices = new Solovis.Portal.SitePortalServices();
        }

        public async doInitAsync() {
            this._exposureProfiles = await this._portalServices.modelEnvironmentCachedData().getExposureProfilesAsync();
        }

        public title() {
            return "Exposure";
        }

        public renderPanel() {           

            $("<p>").appendTo(this.container)
                .html("Pick a <span style='font-weight: bold'>Portfolio</span> and <span style='font-weight: bold'>Exposure Profile</span>"
                    + " below and then go to any of the <span style='font-weight: bold'>Report Suggestions</span> to start looking at "
                    + " exposure (with those required parameters already set).");

            // Portfolio
            $("<h3>").text("Portfolio").appendTo(this.container);

            $("<p>").text("The portfolio defines the set of assets that will be aggregated together for the purposes of analyzing exposure.")
                .appendTo(this.container);

            let portfolioParameters = [
                {
                    name: "assetList", label: "Assets", parameterType: "entityOrInvestment", list: true,
                    help: "All of the individual specified assets will be combined to create a composite for exposure analysis."
                },

                { name: "assetSelectionSet", label: "Asset Selection Set", parameterType: "assetSelectionSet" }
            ];

            this._portfolioParameterSet = new Solovis.Reports.ParameterSet({
                parameters: portfolioParameters
            });

            let portfolioParamDiv = $("<div>").appendTo(this.container);
            let portfolioParamListControl = new Solovis.Reports.Parameters.ParameterListControl({
                controlHost: portfolioParamDiv,
                parameterSet: this._portfolioParameterSet
            });
            portfolioParamListControl.setAsCurrentControl();            

            // Exposure Profile
            $("<h3>").text("Exposure Profile").appendTo(this.container);

            $("<p>").text("The exposure profile classifies holdings according to various taxonomies such as asset class or geography.")
                .appendTo(this.container);

            let defaultProfile = null;            
            if (this._exposureProfiles) {                
                if (this._exposureProfiles.itemList && this._exposureProfiles.itemList.length > 0) {
                    // TODO: Consider whether we should pick first alphabetical or save the last picked exposure profile locally.
                    defaultProfile = { id: this._exposureProfiles.itemList[0].id };
                }
            }

            let profileParameters = [
                {
                    name: "profile", label: "Profile", parameterType: "exposureProfile", initialValue: defaultProfile
                }
            ];

            this._profileParameterSet = new Solovis.Reports.ParameterSet({
                parameters: profileParameters
            });

            let profileParamDiv = $("<div>").appendTo(this.container);
            let profileParamListControl = new Solovis.Reports.Parameters.ParameterListControl({
                controlHost: profileParamDiv,
                parameterSet: this._profileParameterSet
            });
            profileParamListControl.setAsCurrentControl();

            // Report Suggestions

            $("<h3>").text("Report Suggestions").appendTo(this.container);
            this._reportListDiv = $("<div>").appendTo(this.container);

            // Add handlers to update suggested reports.
            $(this._portfolioParameterSet).bind("parameterValueChanged", () => this._updateSuggestedReports());
            $(this._profileParameterSet).bind("parameterValueChanged", () => this._updateSuggestedReports());

            this._updateSuggestedReports();
        }

        private _updateSuggestedReports() {

            let reportCodeForExposureRollUpLineItems = "FEC0D928-9E3D-4FE5-804C-0ECEEF9D8E35";
            let reportCodeForAggregateExposureOverTime = "4CEDDA66-BC11-47AD-B366-914DF96CEDBF";
            let reportCodeForAggregateExposureOverTimeChart = "A698B934-ABD2-4162-A9CF-6BD27E1C8C22";
            let reportCodeForExposureWorldMap = "8AA1EAF5-604B-44DE-9DFE-029129B7D726";   
            let reportCodeForHoldingsExposureByTag = "67D69D81-6D11-4C77-981A-3379E617C98F";
            let reportCodeForHoldingsExposureByTagPivotTable = "D24BC94F-0A72-437B-A5F9-AB589A557A38";

            let links: QuickReportLink[] = [];

            let assetList = this._portfolioParameterSet.getParameterValue("assetList");
            let assetSelectionSet = this._portfolioParameterSet.getParameterValue("assetSelectionSet");
            let profile = this._profileParameterSet.getParameterValue("profile");

            this._reportListDiv.html("");

            // Exposure Roll-up Line Items
            let exposureRollUpLineItemsParams = {
                assetList: assetList,
                assetSelectionSet: assetSelectionSet,
                profile: profile
            };
            links.push({
                label: "Exposure Roll-up Line Items",
                href: Solovis.Reports.ReportLinker.getReportLink({
                    reportCode: reportCodeForExposureRollUpLineItems,
                    parameters: exposureRollUpLineItemsParams,
                    autoRun: true
                }),
                comment: "View detailed exposure data for each holding at lowest available level of look-through.",
                format: "Table"
            });

            // Holdings Exposure By Tag
            let holdingsExposureByTagParams = {
                assetList: assetList,
                assetSelectionSet: assetSelectionSet,
                profile: profile
            };
            links.push({
                label: "Holdings Exposure By Tag",
                href: Solovis.Reports.ReportLinker.getReportLink({
                    reportCode: reportCodeForHoldingsExposureByTag,
                    parameters: holdingsExposureByTagParams,
                    autoRun: true
                }),
                comment: "View exposure for each holding in portfolio where exposure levels are broken out into columns.",
                format: "Table"
            });

            // Holdings Exposure By Tag (Pivot Table)           
            links.push({
                label: "Holdings Exposure By Tag (Pivot Table)",
                href: Solovis.Reports.ReportLinker.getReportLink({
                    reportCode: reportCodeForHoldingsExposureByTagPivotTable,
                    parameters: holdingsExposureByTagParams,
                    autoRun: true
                }),
                comment: "Same as above, in pivot table form.",
                format: "Pivot Table"
            });

            // Aggregate Exposure Over Time
            let aggregateExposureOverTimeParams = {
                assetList: assetList,
                assetSelectionSet: assetSelectionSet,
                profile: profile
            };
            links.push({
                label: "Aggregate Exposure Over Time",
                href: Solovis.Reports.ReportLinker.getReportLink({
                    reportCode: reportCodeForAggregateExposureOverTime,
                    parameters: aggregateExposureOverTimeParams,
                    autoRun: true
                }),
                comment: "View exposure for a portfolio of assets over time.",
                format: "Table"                
            });

            // Aggregate Exposure Over Time Chart
            let aggregateExposureOverTimeChartParams = {
                assetList: assetList,
                assetSelectionSet: assetSelectionSet,
                profile: profile,
                periodLength: "Month",
                periodsBack: 12
            };
            links.push({
                label: "Aggregate Exposure Over Time Chart",
                href: Solovis.Reports.ReportLinker.getReportLink({
                    reportCode: reportCodeForAggregateExposureOverTimeChart,
                    parameters: aggregateExposureOverTimeChartParams,
                    autoRun: true
                }),
                comment: "View chart of exposure for a portfolio of assets over time.",
                format: "Chart"
            });

            // Exposure World Map
            let exposureWorldMapParams = {
                assetList: assetList,
                assetSelectionSet: assetSelectionSet,
                profile: profile
            };
            links.push({
                label: "Exposure World Map",
                href: Solovis.Reports.ReportLinker.getReportLink({
                    reportCode: reportCodeForExposureWorldMap,
                    parameters: exposureWorldMapParams,
                    autoRun: true
                }),
                comment: "View world map view of exposure for a portfolio of assets.",
                format: "Table"
            });

            // Render suggestions.
            BaseQuickStartPanelControl.renderQuickReportLinksToDiv(links, this._reportListDiv);            
        }
    } 


    export class PrivateEquityQuickStartControl extends BaseQuickStartPanelControl {

        private _portalServices: Solovis.Portal.IPortalServices;     

        private _reportListDiv;

        constructor(options) {
            super(options);

            this._portalServices = new Solovis.Portal.SitePortalServices();
        }

        public doInit() {
        }

        public title() {
            return "Private Equity";
        }

        public renderPanel() {            
            $("<h3>").text("Report Suggestions").appendTo(this.container);

            this._reportListDiv = $("<div>").appendTo(this.container);            

            this._updateSuggestedReports();
        }        

        private _updateSuggestedReports() {

            let reportCodeForDrawdownInvestmentList = "8BAF1D95-F96E-4BD6-A06F-3CAA02C7A5AA";
            let reportCodeForDrawdownInvestmentMonthlyCashFlows = "72C6AFA0-5631-4C61-9127-66A1EDC8A1F3";

            $(this._reportListDiv).html("");

            let links: QuickReportLink[] = [];

            // Drawdown Investment List (since inception)
            let drawdownInvestmentListParams = {
                includeSummary: true
            };
            links.push({
                label: "Drawdown Investment List",
                comment: "View all private equity (drawdown) investments with since inception results.",
                href: Solovis.Reports.ReportLinker.getReportLink({
                    reportCode: reportCodeForDrawdownInvestmentList,
                    parameters: drawdownInvestmentListParams,
                    autoRun: true
                }),
                format: "Table"
            });

            // Drawdown Investment Monthly Cash Flows
            let drawdownInvestmentMonthlyCashFlowsParams = {                
            };
            links.push({
                label: "Drawdown Investment Monthly Cash Flows",
                comment: "View quarterly/monthly summary results for a single private equity (drawdown) investment.",
                href: Solovis.Reports.ReportLinker.getReportLink({
                    reportCode: reportCodeForDrawdownInvestmentMonthlyCashFlows,
                    parameters: drawdownInvestmentMonthlyCashFlowsParams,
                    autoRun: false
                }),
                format: "Table"
            });

            BaseQuickStartPanelControl.renderQuickReportLinksToDiv(links, this._reportListDiv);
        }
    }


    export class HoldingsAndPerformanceQuickStartControl extends BaseQuickStartPanelControl {

        private _portalServices: Solovis.Portal.IPortalServices;

        private _reportListDiv;

        constructor(options) {
            super(options);

            this._portalServices = new Solovis.Portal.SitePortalServices();
        }

        public doInit() {
        }

        public title() {
            return "Holdings And Performance";
        }

        public renderPanel() {
            $("<h3>").text("Report Suggestions").appendTo(this.container);

            this._reportListDiv = $("<div>").appendTo(this.container);

            this._updateSuggestedReports();
        }

        private _updateSuggestedReports() {

            let reportCodeForSumOfParts = "30A2F0EE-C2A8-4768-A7B6-85A512E280C8";
            let reportCodeForIntervalStats = "751135CF-6242-44F9-A1A9-59AC19E1A856";

            $(this._reportListDiv).html("");

            let links: QuickReportLink[] = [];

            // Sum of Parts
            let sumOfPartsParams = {
                autoRun: false
            };
            links.push({
                label: "Sum Of Parts",
                comment: "View pro-rata values of underlying portfolio holdings on a customizable look-through basis.",
                href: Solovis.Reports.ReportLinker.getReportLink({
                    reportCode: reportCodeForSumOfParts,
                    parameters: sumOfPartsParams,
                    autoRun: true
                }),
                format: "Table"
            });

            // Interval Statistics
            let intervalStatsParams = {
                autoRun: false
            };
            links.push({
                label: "Interval Statistics",
                comment: "View a wide range of values and calculations (market values, performance - TWR/IRR, standard deviation, PME analyses, transaction summaries, etc.) "
                    +" across a configurable set of time intervals (MTD, QTD, YTD, Since Inception, past few months/quarters/years, etc.).",
                href: Solovis.Reports.ReportLinker.getReportLink({
                    reportCode: reportCodeForIntervalStats,
                    parameters: intervalStatsParams,
                    autoRun: false
                }),
                format: "Table"
            });

            BaseQuickStartPanelControl.renderQuickReportLinksToDiv(links, this._reportListDiv);
        }
    }
}